import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-124">
      {/* Background Image & Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-125">
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop" alt="Luxury apartment interior" className="w-full h-full object-cover opacity-40" data-id="element-126" />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/40 via-zinc-950/80 to-zinc-950" data-id="element-127" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.03)_0%,transparent_100%)]" data-id="element-128" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-129">
        {/* Live Indicator */}
        <FadeIn delay={0.1} data-id="element-130">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-panel mb-8" data-id="element-131">
            <span className="relative flex h-2 w-2" data-id="element-132">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-133"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-134"></span>
            </span>
            <span className="text-xs font-medium tracking-wide uppercase text-zinc-300" data-id="element-135">
              Immersive 360° Experience
            </span>
          </div>
        </FadeIn>

        {/* Headlines */}
        <FadeIn delay={0.2} data-id="element-136">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-semibold tracking-tighter text-gradient mb-6 max-w-5xl mx-auto leading-[1.1]" data-id="element-137">
            Explore Properties Before You Visit
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-138">
          <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed font-light" data-id="element-139">
            MUNISVerse provides immersive virtual property tours and inspections
            for buyers, tenants, developers, corporates, and real estate
            professionals.
          </p>
        </FadeIn>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-zinc-950 to-transparent z-10" data-id="element-140" />
    </section>;
}